import { COCKPIT_LIGHTS, COCKPIT_RADARS } from "../lib/cockpit-lights";

interface CockpitLightsProps {
  adventureId: string;
}

export function CockpitLights({ adventureId }: CockpitLightsProps) {
  const lights = COCKPIT_LIGHTS[adventureId];
  const radars = COCKPIT_RADARS[adventureId];
  if (!lights?.length && !radars?.length) return null;

  return (
    <div className="act-cockpit__effects" aria-hidden>
      {radars?.length ? (
        <div className="act-cockpit__radars">
          {radars.map((screen) => (
            <div
              key={screen.id}
              className={[
                "act-cockpit__radar",
                `act-cockpit__radar--${screen.shape}`,
              ].join(" ")}
              style={{
                left: `${screen.left}%`,
                top: `${screen.top}%`,
                width: screen.width,
                height: screen.height,
              }}
            >
              <span
                className="act-cockpit__radar-sweep"
                style={{
                  animationDuration: `${screen.duration}s`,
                  animationDelay: `${screen.delay}s`,
                }}
              />
              <span
                className="act-cockpit__radar-blip"
                style={{ animationDuration: `${screen.duration}s` }}
              />
            </div>
          ))}
        </div>
      ) : null}

      {lights?.length ? (
        <div className="act-cockpit__lights">
          {lights.map((light) => (
            <span
              key={light.id}
              className={[
                "act-cockpit__light",
                `act-cockpit__light--${light.color}`,
                `act-cockpit__light--${light.shape}`,
                `act-cockpit__light--${light.animation}`,
              ].join(" ")}
              style={{
                left: `${light.left}%`,
                top: `${light.top}%`,
                width: light.width,
                height: light.height,
                animationDuration: `${light.duration}s`,
                animationDelay: `${light.delay}s`,
              }}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
